import { render, staticRenderFns } from "./FiltersWrapper.vue?vue&type=template&id=bd0ba484&scoped=true"
import script from "./FiltersWrapper.vue?vue&type=script&lang=ts"
export * from "./FiltersWrapper.vue?vue&type=script&lang=ts"
import style0 from "./FiltersWrapper.vue?vue&type=style&index=0&id=bd0ba484&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0ba484",
  null
  
)

export default component.exports